import graphql__4970e336ea6c91b22c73 from "./__generated__/AnswerAddress_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import Field from "../Form/Field";
import ShallowAnswer from "./ShallowAnswer";

const AnswerAddress = props => {
  const { answers, formField } = useFragment(AnswerAddress_answer, props.answer);
  const { fieldName, hide } = formField;

  const fieldNames = answers.map(({ formField: { fieldName } }) => fieldName);
  const schema = { type: "address", fieldNames };

  return (
    <Field fieldName={fieldName} schema={schema} hide={hide} label={false}>
      {answers.map(answer => (
        <ShallowAnswer key={answer.id} answer={answer} parent={fieldName} />
      ))}
    </Field>
  );
};

const AnswerAddress_answer = graphql__4970e336ea6c91b22c73;

export default AnswerAddress;
